import {
    useContext,
    useMemo,
} from 'react';

import AuthContext from '@/contexts/auth';
import {
    can as canPure,
    canAll as canAllPure,
    canAny as canAnyPure,
    hasAnyNamespace as hasAnyNamespacePure,
    hasNamespace as hasNamespacePure,
    type RbacSnapshot,
} from '@/lib/rbac';

interface UseRbacReturn {
    rbac: RbacSnapshot | null;
    isOwner: boolean;
    permissions: string[];
    can: (codename?: string | null) => boolean;
    canAny: (codenames: string[]) => boolean;
    canAll: (codenames: string[]) => boolean;
    hasNamespace: (namespace: string) => boolean;
    hasAnyNamespace: (namespaces: string[]) => boolean;
    refreshRbac: () => Promise<void>;
}

export function useRbac(): UseRbacReturn {
    const { rbac, refreshRbac } = useContext(AuthContext);

    return useMemo(() => ({
        rbac,
        isOwner: !!rbac?.isOwner,
        permissions: rbac?.permissions ?? [],
        can: (codename?: string | null) => canPure(rbac, codename),
        canAny: (codenames: string[]) => canAnyPure(rbac, codenames),
        canAll: (codenames: string[]) => canAllPure(rbac, codenames),
        hasNamespace: (namespace: string) => hasNamespacePure(rbac, namespace),
        hasAnyNamespace: (namespaces: string[]) => hasAnyNamespacePure(rbac, namespaces),
        refreshRbac,
    }), [rbac, refreshRbac]);
}
